<template>
    <div class="block shadow-lg bg-white p-8 mb-6">
        <div v-if="loading">
            <loader />
        </div>
        <div v-else>
            <slot />
        </div>
    </div>
</template>

<script>
    import Loader from '@/components/Loader'

    export default {
        props: {
            loading: {
                type: Boolean,
                default: true,
                required: true
            }
        },

        components: {
            Loader
        }
    }
</script>
